import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../api/auth";
import "./Login-ForgotPassword-ResetPassword.css";

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [token, setToken] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const isInitialSetPassword = searchParams.get("initial") === "1";

  useEffect(() => {
    const tokenFromUrl = searchParams.get("token");

    if (!tokenFromUrl) {
      setError("Invalid or missing reset token.");
      setIsSuccess(false);
      return;
    }

    setToken(tokenFromUrl);
  }, [searchParams]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setIsSuccess(false);

    if (!token) {
      setError("Invalid or missing reset token.");
      return;
    }

    if (!formData.password || !formData.confirmPassword) {
      setError("All fields are required");
      return;
    }

    try {
      setLoading(true);
      const res = await resetPassword({
        token,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
      });

      setIsSuccess(true);
      setMessage(
        res?.message ||
          (isInitialSetPassword
            ? "Password set successfully. You can now sign in."
            : "Password reset successful"),
      );
    } catch (err: any) {
      setIsSuccess(false);
      setError(err.response?.data?.message || "Password reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <div>
          <h2>Reset Password</h2>
          <p className="reset-password-centered-text">
            Please enter your new password below.
          </p>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}

        {!isSuccess && (
          <form onSubmit={handleSubmit} className="login-form">
            <label htmlFor="password" className="sr-only">
              New Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="New Password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <label htmlFor="confirmPassword" className="sr-only">
              Confirm New Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="Confirm New Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <button
              id="login-btn"
              type="submit"
              className="btn"
              disabled={loading}
            >
              {loading
                ? "Updating..."
                : isInitialSetPassword
                  ? "Set password"
                  : "Reset Password"}
            </button>
          </form>
        )}

        {isSuccess && (
          <button className="btn" onClick={() => navigate("/login")}>
            Go to Login
          </button>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
